// @flow

export const NAME = 'name';
export const AGE_IN_DAYS = 'ageInDays';
export const IS_PREMIUM = 'isPremium';
export const POPULARITY = 'popularity';
export const ALL = 'All';

export const serviceTypes = {
  [POPULARITY]: 'Popular',
  [NAME]: 'Alphabetical',
  [AGE_IN_DAYS]: 'Recently Added',
  [IS_PREMIUM]: 'Premium',
};

export const nodeTypes = {
  FILTER: 'filter',
  WRITE: 'write',
  SEARCH_OR_WRITE: 'search_or_write',
  READ: 'read',
  SEARCH: 'search',
  HAS_READS: 'hasReads',
  HAS_WRITES: 'hasWrites',
  HAS_SEARCHES: 'hasSearches',
  HAS_FILTERS: 'hasFilters',
  HAS_SEARCH_OR_WRITE: 'hasSearchOrWrites',
  POLLING: 'polling',
  RESTHOOK: 'resthook',
  HOOK: 'hook',

  // pseudo frontend only type for now, but should become a true backend type eventually.
  PATHS_GROUP: 'paths_group',
};

export const blacklistedServices = {
  FilterAPI: true,
};
